import { render, staticRenderFns } from "./dataarchive.vue?vue&type=template&id=074850e3&scoped=true&"
import script from "./dataarchive.vue?vue&type=script&lang=js&"
export * from "./dataarchive.vue?vue&type=script&lang=js&"
import style0 from "./dataarchive.vue?vue&type=style&index=0&id=074850e3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "074850e3",
  null
  
)

export default component.exports